import * as angular from 'angular';

class DosespotButtonController {
  private visit: any;
  private dosespotWindow: any;
  constructor(
    private toastr: any,
    private Dosespot: any,
    private Utils: any
  ) {
    'ngInject';
    Object.assign(this, {
      toastr,
      Dosespot,
      Utils,
    });

  }


  openDosespot() {
    const { user: patient } = this.visit;
    if (!patient.properties || !patient.properties.dosespot) {
      // Create patient if dosespot property does not exist
      this.Dosespot.createPatient(patient)
      // @ts-ignore
        .then(({ data }) => {
          // Assign property locally
          patient.properties = patient.properties || {};
          patient.properties.dosespot = data.patient_id;
          this.getPatientLink(patient);
        })
      // @ts-ignore
        .catch(({ data: err }) => {
          this.Utils.createErrorToast(err, 'Failed to create patient in Dosespot.');
        });
    } else {
      // Open Dosespot if patient is already registered in Dosespot
      this.getPatientLink(patient);
    }
  }


  getPatientLink(patient: any) {
    this.Dosespot.getPatientLink(patient)
      .then((url: any) => {
        var old_window;
        if (this.dosespotWindow) {
          old_window = this.dosespotWindow;
        }
        this.dosespotWindow = null;
        this.dosespotWindow = window.open(url, '_blank', 'toolbar=0,location=0,menubar=0');
        this.dosespotWindow.onbeforeunload = () => {
          this.dosespotWindow = null;
        };
        if (old_window) {
          old_window.close();
        }
      })
      .catch(() => this.toastr.error('Patient information is invalid'));
  }
}
DosespotButtonController.$inject = ["toastr", "Dosespot", "Utils"];
angular.module('pims').component('dosespotButton', {
  template: `
      <button
        class="btn btn-grey-outline"
        ng-click="vm.openDosespot();",
        ng-disabled="vm.isDisabled"
        style="width: 231px;">
        Open Dosespot
      </button>
  `,
  controller: DosespotButtonController,
  controllerAs: 'vm',
  bindings: {
    defaultClasses: '<',
    errorClasses: '<',
    visit: '<',
    isDisabled: '<',
    customClasses: '<',
  },
});
